import React, { useContext } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import Image from "mui-image";

import useTruncateString from "hooks/useTruncateString";

import { UserContext } from "utils/UserContext";
import { handleCurrentDate, handleCurrentTime } from "utils/timeUtils";
import { handleFavMaxChars, handleLogoMaxWidth } from "utils/customStylesUtils";
import PropTypes from "prop-types";
import GoldStar from "../../assets/images/extraIcons/gold-star.png";
import COMPLogo from "../../assets/images/logo/comp-logo.png";

function TimeOfImage({ displayOnly, widthBelowSm }) {
  const { selectedScoreType, favSongs } = useContext(UserContext);

  const handleTruncatedString = useTruncateString();

  const currentDate = handleCurrentDate();

  const currentTime = handleCurrentTime();

  const favSongsElements = favSongs.map((fav) => (
    <ListItem
      key={fav}
      sx={{
        marginTop: "-4px",
        marginBottom: !displayOnly ? "8px" : 0,
      }}
      disableGutters
    >
      <ListItemIcon>
        <img
          src={GoldStar}
          alt=""
          width={widthBelowSm && displayOnly ? "10px" : "15px"}
        />
      </ListItemIcon>
      <ListItemText
        primary={handleTruncatedString({
          customText: fav,
          customVariant: !displayOnly ? "body2" : "caption",
          customComponent: "span",
          customSx: {
            WebkitLineClamp: 1,
            paddingBottom: 0,
            fontSize: widthBelowSm && displayOnly && "0.5rem",
          },
          maxCharacters: {
            sm: handleFavMaxChars(displayOnly, widthBelowSm),
            smToMd: handleFavMaxChars(displayOnly, widthBelowSm),
            aboveMd: handleFavMaxChars(displayOnly, widthBelowSm),
          },
        })}
      />
    </ListItem>
  ));

  return (
    <Grid
      container
      item
      xs={4}
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={4}
      sx={{
        flexWrap: "nowrap",
      }}
    >
      <Grid item xs={4}>
        {favSongs.length === 0 ? (
          <Paper />
        ) : (
          <List dense>{favSongsElements}</List>
        )}
      </Grid>

      <Grid item xs={4}>
        <Image
          src={COMPLogo}
          alt="COMP Logo"
          duration={0}
          sx={{
            maxWidth: handleLogoMaxWidth(displayOnly, widthBelowSm),
          }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          textAlign: "right",
        }}
      >
        <List dense>
          <ListItem
            sx={{
              marginTop: "-4px",
              marginBottom: !displayOnly ? "8px" : 0,
              textAlign: "right",
            }}
            disableGutters
          >
            <ListItemText
              primary={
                <Typography
                  variant={!displayOnly ? "body2" : "caption"}
                  component="span"
                  sx={{
                    WebkitLineClamp: 1,
                    paddingBottom: 0,
                    fontSize: widthBelowSm && displayOnly && "0.5rem",
                  }}
                >
                  {currentDate.display}
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            sx={{
              marginTop: "-4px",
              marginBottom: !displayOnly ? "8px" : 0,
              textAlign: "right",
            }}
            disableGutters
          >
            <ListItemText
              primary={
                <Typography
                  variant={!displayOnly ? "body2" : "caption"}
                  component="span"
                  sx={{
                    WebkitLineClamp: 1,
                    paddingBottom: 0,
                    fontSize: widthBelowSm && displayOnly && "0.5rem",
                  }}
                >
                  {currentTime.display}
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            sx={{
              marginTop: "-4px",
              marginBottom: !displayOnly ? "8px" : 0,
              textAlign: "right",
            }}
            disableGutters
          >
            <ListItemText
              primary={
                <Typography
                  variant={!displayOnly ? "body2" : "caption"}
                  component="span"
                  sx={{
                    WebkitLineClamp: 1,
                    paddingBottom: 0,
                    fontSize: widthBelowSm && displayOnly && "0.5rem",
                  }}
                >
                  {selectedScoreType}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
}

TimeOfImage.propTypes = {
  displayOnly: PropTypes.bool.isRequired,
  widthBelowSm: PropTypes.bool.isRequired,
};

export default TimeOfImage;
